import { getCompanyTaxes } from './api';

export const ALL_COMPANY_TAXES = {
  cacheKey: 'ALL_COMPANY_TAXES',
  apiFunction: getCompanyTaxes
};
